const signupUI = {
  default: {
    fields: ["user_name", "email", "password", "confirm_password"],
  },
};

export default signupUI;
